import { useEffect, useState } from "react";
import { Fingerprint, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAppLock } from "@/hooks/useAppLock";

/**
 * Cobertura de tela exibida quando o bloqueio biométrico está ativo e o app
 * acabou de abrir (ou voltou do background). Só aparece no app nativo.
 */
const AppLockGate = () => {
  const { locked, unlock, label } = useAppLock();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!locked) return;
    // Tenta desbloquear imediatamente para não exigir um toque extra.
    setBusy(true);
    unlock().finally(() => setBusy(false));
  }, [locked, unlock]);

  if (!locked) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-6 bg-background/98 backdrop-blur-xl px-8 text-center"
      role="dialog"
      aria-modal="true"
      aria-label="Zappy bloqueado"
    >
      <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
        <Lock className="w-8 h-8 text-primary" aria-hidden="true" />
      </div>
      <div className="space-y-2">
        <h1 className="font-display text-xl text-foreground">Zappy bloqueado</h1>
        <p className="font-body text-sm text-muted-foreground max-w-xs">
          Use {label} para abrir o app. Suas conversas e seu perfil ficam protegidos mesmo se
          alguém pegar seu celular desbloqueado.
        </p>
      </div>
      <Button
        onClick={() => {
          setBusy(true);
          unlock().finally(() => setBusy(false));
        }}
        disabled={busy}
        className="gap-2"
      >
        <Fingerprint className="w-4 h-4" aria-hidden="true" />
        {busy ? "Aguardando..." : `Desbloquear com ${label}`}
      </Button>
    </div>
  );
};

export default AppLockGate;
